

















import {Component, Vue} from 'vue-property-decorator';
import TableRoute from '@c/tables/TableRoute.vue';
import {Can} from '@casl/vue';
import {DiagnosticAssistanceTableHeader} from './interfaces';
import diagnosticAssistanceStoreModule from '@/store/modules/services/diagnosticAssistanceModule';

@Component({
  components: {
    TableRoute,
    Can,
  },
})
export default class DiagnosticAssistanceView extends Vue {
  headers: DiagnosticAssistanceTableHeader[] = [
    {
      text: 'Наименование',
      value: 'name',
      sortable: false,
    },
  ];

  get apiStore() {
    return diagnosticAssistanceStoreModule;
  }
}
